import axios, { AxiosError } from "axios"

import { MODULE_PATH, MODULE_VIEW_PATH } from "../../constants/paths"
import {
  requestInterceptorSuccessCredentials,
  requestInterceptorErrorSecurityCredentials,
  responseInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials,
} from "interceptors"

const instance = axios.create({
  baseURL: process.env.REACT_APP_CREDENTIALS_API_SERVICE_DOMAIN,
})

instance.interceptors.request.use(
  requestInterceptorSuccessCredentials,
  requestInterceptorErrorSecurityCredentials
)

instance.interceptors.response.use(
  responseInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials
)

export const getModuleViewsByModuleIdService = async (id: number) => {
  try {
    const result = await instance.get(MODULE_PATH + "/" + id + MODULE_VIEW_PATH)
    return result.data
  } catch (error) {
    throw new Error((error as AxiosError)?.response?.data)
  }
}

export const createModuleViewsByModuleIdService = async (
  id: number,
  moduleViews: any
) => {
  try {
    const result = await instance.post(
      MODULE_PATH + "/" + id + MODULE_VIEW_PATH,
      moduleViews
    )
    return result.data
  } catch (error) {
    throw new Error((error as AxiosError)?.response?.data)
  }
}
